import { createSelector } from 'reselect'
import legendsToRender from '../utility/legendsToRender'

const getLayersRendered = (state, authId) => {
  return state.layer.layersRendered
}

const getAuthLayers = state => {
  return state.login.layers
}

const getServiceLayers = state => {
  return state.service.layers
}

export const getLegendsToRender = createSelector(
  [getLayersRendered, getAuthLayers, getServiceLayers],
  (layersRendered, authLayers, serviceLayers) => {
    const legends = legendsToRender(layersRendered, authLayers, serviceLayers)

    return legends
  }
)



// WEBPACK FOOTER //
// ./src/selectors/legendSelector.js